import { render, staticRenderFns } from "./PayButton.vue?vue&type=template&id=4cdbeb66&scoped=true"
import script from "./PayButton.vue?vue&type=script&lang=js"
export * from "./PayButton.vue?vue&type=script&lang=js"
import style0 from "./PayButton.vue?vue&type=style&index=0&id=4cdbeb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbeb66",
  null
  
)

export default component.exports